import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';
import { getToken, generateUUID } from './../utils';
import { API_BASE_URL } from '@env';

export const baseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: async (headers) => {
    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    headers.set('correlation-id', generateUUID());
    const token = await getToken();
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

// Base query for unauthenticated requests (for bypass OTP flow)
export const unauthenticatedBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: async (headers) => {
    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    headers.set('correlation-id', generateUUID());
    // Explicitly do not add Authorization header
    return headers;
  },
});

export const QApi = createApi({
  reducerPath: 'QApi',
  baseQuery: baseQuery,
  refetchOnFocus: false, // CRITICAL: Prevent API calls on scroll/focus
  tagTypes: ['UserApi', 'QueueApi', 'UiApi'],
  endpoints: () => ({}),
});

// Separate API instance for unauthenticated requests
export const PublicQApi = createApi({
  reducerPath: 'PublicQApi',
  baseQuery: unauthenticatedBaseQuery,
  refetchOnFocus: false, // CRITICAL: Prevent API calls on scroll/focus
  tagTypes: ['PublicQueueApi'],
  endpoints: () => ({}),
});
